import * as type from "../../types/API/contactUsType";

export function addContactUs(payload: any) {
  return {
    type: type.ADD_CONTACT_US,
    payload: payload,
  };
}

export function getContactUs(payload: any) {
  return {
    type: type.GET_CONTACT_US,
    payload: payload,
  };
}
